<template>
  <div
    class="text-subtitle1 text-weight-bold q-pl-sm q-py-xs"
    :class="$q.dark.mode === true ? 'text-grey-2' : 'text-primary'"
  >
    {{ title }}
  </div>
</template>
<script>
export default {
  name: "titleTitle",
};
</script>
<script setup>
const props = defineProps({
  title: {
    type: String,
  },
});
</script>
